import type { VariantResource } from "../../variant";
import type { CustomerGroupResource } from "../../customer-group";
import type { ProductGroupResource } from "../../product-group";
import type { CountryResource } from "../../country";
import type { CustomerResource } from "../../customer";
import type { NoteResource } from "../../note";
import type { MarketplaceResource } from "../../marketplace";
import type { VoucherResource } from "../../voucher";
import type { ProductResource } from "../../product";
import type { Nullable } from "../../../common.ts";

export enum VoucherStatus {
  Active = "active",
  Inactive = "inactive",
  ActiveDuringPeriod = "active_during_period",
}

export interface VoucherSerieResource {
  id: string;
  gid: string;
  title: string;
  is_active: boolean;
  description: string;
  active_from: string | null;
  active_to: string | null;
  discount_amount: string;
  is_discount_percent: boolean;
  min_value: string;
  max_value: string;
  is_value_net: boolean;
  is_discount_net: boolean;
  is_allow_same_series: boolean;
  is_allow_other_series: boolean;
  is_allow_use_an_other: boolean;

  marketplace: MarketplaceResource | null;

  vouchers?: VoucherResource[];

  vouchersAvailable?: number;
  vouchersUsed?: number;

  excluded_variants?: VariantResource[];
  excluded_variants_count: number;
  included_variants?: VariantResource[];
  included_variants_count: number;

  excluded_products?: ProductResource[];
  excluded_products_count: number;
  included_products?: ProductResource[];
  included_products_count: number;

  excluded_product_groups?: ProductGroupResource[];
  excluded_product_groups_count: number;
  included_product_groups?: ProductGroupResource[];
  included_product_groups_count: number;

  excluded_customer_groups?: CustomerGroupResource[];
  excluded_customer_groups_count: number;
  included_customer_groups?: CustomerGroupResource[];
  included_customer_groups_count: number;

  excluded_countries?: CountryResource[];
  excluded_countries_count: number;
  included_countries?: CountryResource[];
  included_countries_count: number;

  excluded_customers?: CustomerResource[];
  excluded_customers_count: number;
  included_customers?: CustomerResource[];
  included_customers_count: number;

  notes?: NoteResource[];
  notes_count: number;
  vouchers_count: number;
  vouchers_used_count: number;
  vouchers_avail_count: number;
}

export interface VoucherSerieUpdateRequest {
  title?: Nullable<string>;
  is_active?: Nullable<boolean>;
  active_from?: Nullable<string>;
  active_to?: Nullable<string>;
  discount_amount?: Nullable<string>;
  min_value?: Nullable<number>;
  max_value?: Nullable<number>;
  is_discount_percent?: Nullable<boolean>;
  is_allow_same_series?: Nullable<boolean>;
  is_allow_other_series?: Nullable<boolean>;
  is_allow_use_an_other?: Nullable<boolean>;
}

export interface GetVoucherSerieResponse {
  data: VoucherSerieResource;
}

export interface VoucherSerieStoreRequest {
  title: string;
  description?: Nullable<string>;
  active_from?: Nullable<string>;
  active_to?: Nullable<string>;
  discount_amount?: Nullable<string>;
  min_value?: Nullable<number>;
  max_value?: Nullable<number>;
  marketplace_id?: Nullable<string>;
  is_discount_net?: Nullable<boolean>;
  is_discount_percent?: Nullable<boolean>;
  is_allow_same_series?: Nullable<boolean>;
  is_allow_other_series?: Nullable<boolean>;
  is_allow_use_an_other?: Nullable<boolean>;
}
